import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconErase = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M29.2842 17.8044L22.2308 10.751L14.6609 18.3209L21.7143 25.3743L29.2842 17.8044ZM13.0045 20.1026L19.8624 26.9604L18.1594 28.6634C17.3783 29.4445 16.112 29.4445 15.331 28.6634L11.3015 24.634C10.5205 23.853 10.5205 22.5866 11.3015 21.8056L13.0045 20.1026Z",
		fill: "#707070"
	})
});
export default SvgIconErase;
